export default __webpack_public_path__ + "static/media/background-home.c6ad69e9.jpg";